import { useEffect } from 'react'
import _get from 'lodash/get'
import _map from 'lodash/map'
import _parseInt from 'lodash/parseInt'
import _split from 'lodash/split'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import { URL_HOME, URL_PLAYLIST_WATCH_LATER } from '../../services/url/constants'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import { handleRedirect } from './utils'

function GoAddToPlaylistRest (props) {
  const {
    setOverlayDialogVisible,
    batchPlaylistItems,
    location,
    history,
    user,
    auth,
  } = props

  const isLoggedIn = getAuthIsLoggedIn(auth)
  const playlistAdd = _get(location, ['query', 'playlistAdd'])
  const redirectTo = _get(location, ['query', 'url'])
  const contentIds = _map(_split(playlistAdd, ','), _parseInt)

  const handleAddToPlaylist = () => {
    if (contentIds && contentIds.length > 0) {
      handleRedirect({
        history,
        auth,
        user,
        url: redirectTo || URL_PLAYLIST_WATCH_LATER,
      })
      batchPlaylistItems({ ids: contentIds, type: 'default', add: true })
    } else {
      handleRedirect({
        history,
        auth,
        user,
        url: URL_HOME,
      })
    }
  }

  useEffect(() => {
    if (!isLoggedIn) {
      setOverlayDialogVisible(TYPE_LOGIN)
    } else {
      handleAddToPlaylist()
    }
  }, [isLoggedIn])

  return null
}

GoAddToPlaylistRest.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  batchPlaylistItems: PropTypes.func.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    batchPlaylistItems: actions.playlist.batchPlaylistItems,
    setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
  }
})(GoAddToPlaylistRest)
